import { createSelector } from 'reselect';
import { isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';
import {
    REWARDS_DESIGN_COOKIE_FLAGNAME,
    REWARDS_DESIGN_HEADER_FLAGNAME,
} from '../common/Constants';

export const DEFAULTS = {};

const isRewardsRedesignEnabled = (featureFlags, preferences, reqHeaders) =>
    isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,          cookieName                      headerName
        'enableRewardsRedesign',
        REWARDS_DESIGN_COOKIE_FLAGNAME,
        REWARDS_DESIGN_HEADER_FLAGNAME
    );

// FF
export const selectRewardsRedesignThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isRewardsRedesignEnabled
);
